"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStripeSetupSecret = exports.StripeSetupSecretProvider = void 0;
const React = require("react");
const react_1 = require("react");
const useClient_1 = require("../../../../../hooks/useClient");
const StripeSecretContext = (0, react_1.createContext)({});
const StripeSetupSecretProvider = ({ children }) => {
    const [stripeSecret, setStripeSecret] = (0, react_1.useState)();
    const client = (0, useClient_1.useClient)();
    const retailCustomerId = (0, react_1.useMemo)(() => client.auth.session &&
        client.auth.session.retailCustomer &&
        client.auth.session.retailCustomer.id, [client.auth.session]);
    const loadSetupSecret = async () => {
        if (!retailCustomerId)
            return;
        let result = await client.retailCustomers.setupActivePaymentMethod(retailCustomerId);
        if (result && result.setupSecret) {
            setStripeSecret(result.setupSecret);
        }
    };
    (0, react_1.useEffect)(() => {
        loadSetupSecret();
    }, []);
    let myContext = {
        setupIntentSecret: stripeSecret
    };
    return (React.createElement(StripeSecretContext.Provider, { value: myContext }, children));
};
exports.StripeSetupSecretProvider = StripeSetupSecretProvider;
const useStripeSetupSecret = () => {
    const context = (0, react_1.useContext)(StripeSecretContext);
    if (context === undefined) {
        throw new Error("useStripePromise must be used within a StripePromiseProvider");
    }
    return context;
};
exports.useStripeSetupSecret = useStripeSetupSecret;
//# sourceMappingURL=StripeSetupSecretProvider.js.map